import { Edashboard } from "../../features/employerDashboard/Edashboard";


export function EdashPage() {
  return (
    <div>
      {/* <Dummy /> */}
      <Edashboard />
    </div>
  );
}
